import { useMemo } from 'react';
import type { BusinessHoursDto } from '@/services/api/petseo.client.wrapper';
import type { ScheduleDayFormData } from '@/schemas/schedule.schema';
import { isBusinessHoursMissing, isScheduleOutsideBusinessHours } from '../utils';

interface ScheduleBusinessHoursValidation {
  hasNoBusinessHoursDefined: boolean;
  hasScheduleOutsideBusinessHours: boolean;
}

export const useScheduleBusinessHoursValidation = (
  days: ScheduleDayFormData[],
  businessHours: BusinessHoursDto[] | undefined
): ScheduleBusinessHoursValidation => {
  const hasNoBusinessHoursDefined = useMemo(() => isBusinessHoursMissing(businessHours), [businessHours]);

  const hasScheduleOutsideBusinessHours = useMemo(() => isScheduleOutsideBusinessHours(days, businessHours), [days, businessHours]);

  return { hasNoBusinessHoursDefined, hasScheduleOutsideBusinessHours };
};
